import {useCallback} from 'react';
import useUpdatePayinSessionMutation from 'src/api/graphql/useUpdatePayinSessionMutation';
import {getStore} from 'src/v2/state/store';

export const useUpdateCustomerEmail = (): [
  (customerEmail: string) => Promise<void>,
  {loading: boolean},
] => {
  const store = getStore();
  const [updatePayinSessionMutation, {loading}] =
    useUpdatePayinSessionMutation();
  const sessionId = store.useSelector((state) => state.id);
  const clientSecret = store.useSelector((state) => state.clientSecret);

  const updateCustomerEmail = useCallback(
    async (customerEmail: string) => {
      await updatePayinSessionMutation({
        variables: {
          input: {
            client_secret: clientSecret,
            crypto_payin_session: sessionId,
            customer_email: customerEmail,
          },
        },
      });
    },
    [sessionId, clientSecret, updatePayinSessionMutation],
  );

  return [updateCustomerEmail, {loading}];
};
